import React from 'react';
import { Container, Typography, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import SEO from '../components/SEO';

const FeeStructure = () => {
  const hindiMediumFees = [
    {
      course: "6th-8th",
      duration: "",
      subjects: "All Subjects",
      fee: "₹10,000"
    },
    {
      course: "9th-10th",
      duration: "",
      subjects: "All Subjects",
      fee: "₹20,000"
    },
    {
      course: "11th-12th Science",
      duration: "",
      subjects: "Physics, Chemistry, Maths, Biology",
      fee: "₹30,000"
    },
    {
      course: "NEET-JEE",
      duration: "",
      subjects: "Physics, Chemistry, Maths, Biology",
      fee: "₹40,000"
    }
  ];

  const englishMediumFees = [
    {
      course: "6th-8th",
      duration: "",
      subjects: "All Subjects",
      fee: "₹20,000"
    },
    {
      course: "9th-10th",
      duration: "",
      subjects: "All Subjects",
      fee: "₹30,000"
    },
    {
      course: "11th-12th Science",
      duration: "",
      subjects: "Physics, Chemistry, Maths, Biology",
      fee: "₹40,000"
    },
    {
      course: "NEET-JEE",
      duration: "",
      subjects: "Physics, Chemistry, Maths, Biology",
      fee: "₹50,000"
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <SEO 
        title="Fee Structure - SOLID CLASSES"
        description="View our transparent and competitive fee structure for Hindi and English medium classes from 6th to 12th standard, including NEET-JEE preparation at SOLID CLASSES."
        keywords="SOLID CLASSES fees, fee structure, course fees, NEET JEE coaching fees, best coaching fees in Jodhpur, affordable coaching"
      />
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Fee Structure
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph align="center" sx={{ mb: 6 }}>
        Transparent and competitive pricing for quality education
      </Typography>

      {/* Hindi Medium Fee Structure */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        Hindi Medium
      </Typography>
      <TableContainer component={Paper} sx={{ mb: 6 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Course</TableCell>
              <TableCell>Subjects</TableCell>
              <TableCell align="right">Fee (INR)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {hindiMediumFees.map((row, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  {row.course}
                </TableCell>
                <TableCell>{row.subjects}</TableCell>
                <TableCell align="right">{row.fee}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* English Medium Fee Structure */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        English Medium
      </Typography>
      <TableContainer component={Paper} sx={{ mb: 6 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Course</TableCell>
              <TableCell>Subjects</TableCell>
              <TableCell align="right">Fee (INR)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {englishMediumFees.map((row, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  {row.course}
                </TableCell>
                <TableCell>{row.subjects}</TableCell>
                <TableCell align="right">{row.fee}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Additional Information:
        </Typography>
        <Typography variant="body1" paragraph>
          • All fees are inclusive of study material
        </Typography>
        <Typography variant="body1" paragraph>
          • Payment can be made in installments
        </Typography>
        <Typography variant="body1" paragraph>
          • Special discounts available for early enrollment
        </Typography>
        <Typography variant="body1" paragraph>
          • For detailed fee structure and payment plans, please contact our office
        </Typography>
      </Box>
    </Container>
  );
};

export default FeeStructure; 
